import {AnyAction} from 'redux'
import {crudReducer, CrudState, initialCrudState} from 'lib/crud'

export const name = 'STUDENT_FILE_TYPE'

export type StudentFileTypeState = {
    crud: CrudState,
}

const initialState = {
    crud: initialCrudState,
}

export function studentFileTypeReducer(state: StudentFileTypeState = initialState, action: AnyAction): StudentFileTypeState {
    switch (action.type) {
        default:
            return {
                ...state,
                crud: crudReducer(name, state.crud, action)
            }
    }
}
